import React from 'react'
import './letter.css'

const Letter = ({ letter, ...props }) => <div  {...props} className={`letter ${letter}`} />

export default Letter